import React, {useState, useEffect} from "react";
import {withTranslation} from "react-i18next";
import "../center.scss";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import variables from "../../../_constants/variables";
import {Button, Form, Input, Space} from "antd";
import {PlusOutlined, MinusCircleOutlined} from "@ant-design/icons";
import {xcService} from "../../../_services/xcService";

function StepTwoCenter(props) {
  const storage = localOrSessionStore({key: variables.REMEMBER});
  const user = JSON.parse(storage.getItem(variables.USER));
  const [form] = Form.useForm();
  const {t, i18n} = props;
  const [loading, setLoading] = useState(false);

  const [number, setNumber] = useState(1);

  const onFinish = (vals) => {
    props.goTo(vals, 2);
  };

  useEffect(() => {
    xcService.get("/v1/tutor/contractemp/" + user.code).then((data) => {
      if (data.data.data && data.data.data.code) {
        const {setFieldsValue, getFieldValue} = form;
        try {
          let mData = JSON.parse(data.data.data.values2);

          setFieldsValue(mData);
        } catch (e) {
          console.error(e);
        }
      }
    });
  });

  return (
    <Form
      className="authForm allHeightMobile"
      form={form}
      onFinish={onFinish}
      name="basic"
      layout="vertical"
      initialValues={{remember: true}}
      autoComplete="off"
    >
      <div className={"customLabel"} style={{marginBottom: 10}}>
        {t("registercenter.director.title")}
      </div>
      <Form.Item
        rules={[
          {
            required: true,
            message: t("mandatory"),
          },
        ]}
        label={t("registercenter.director.nombre")}
        name={"directorName"}
      >
        <Input placeholder={t("registercenter.placenom")} />
      </Form.Item>
      <Form.Item
        rules={[
          {
            required: true,
            message: t("mandatory"),
          },
        ]}
        label={t("registercenter.director.apellidos")}
        name={"directorSurname"}
      >
        <Input placeholder={t("registercenter.placesur")} />
      </Form.Item>
      <Form.Item
        rules={[
          {
            type: "email",
            message: t("registro.emailIncorrect"),
          },
          {
            required: true,
            message: t("mandatory"),
          },
        ]}
        label={t("registercenter.director.email")}
        name={"directorEmail"}
      >
        <Input placeholder={t("registercenter.placeemail")} />
      </Form.Item>
      <Form.Item
        rules={[
          {
            required: true,
            message: t("mandatory"),
          },
          ({getFieldValue}) => ({
            validator(_, value) {
              var DNI_REGEX = /^(\d{8})([A-Z])$/;
              value = value.toUpperCase().replace(/\s/, "");
              if (value.match(DNI_REGEX)) {
                var dni_letters = "TRWAGMYFPDXBNJZSQVHLCKE";
                var letter = dni_letters.charAt(parseInt(value, 10) % 23);
                if (letter === value.charAt(8)) return Promise.resolve();
                else return Promise.reject(new Error(t("registro.baddni")));
              } else {
                return Promise.reject(new Error(t("registro.baddni")));
              }
            },
          }),
        ]}
        label={t("registercenter.director.dni")}
        name={"directorDni"}
      >
        <Input placeholder={"1234567X"} />
      </Form.Item>

      <div className={"customLabel"} style={{marginTop: 20, marginBottom: 10}}>
        {t("registercenter.jefe.title")}
      </div>
      <Form.Item
        rules={[
          {
            required: true,
            message: t("mandatory"),
          },
        ]}
        label={t("registercenter.jefe.nombre")}
        name={"jefeName"}
      >
        <Input placeholder={t("registercenter.placenom")} />
      </Form.Item>
      <Form.Item
        rules={[
          {
            required: true,
            message: t("mandatory"),
          },
        ]}
        label={t("registercenter.jefe.apellidos")}
        name={"jefeSurname"}
      >
        <Input placeholder={t("registercenter.placesur")} />
      </Form.Item>
      <Form.Item
        rules={[
          {
            type: "email",
            message: t("registro.emailIncorrect"),
          },
          {
            required: true,
            message: t("mandatory"),
          },
        ]}
        label={t("registercenter.jefe.email")}
        name={"jefeEmail"}
      >
        <Input placeholder={t("registercenter.placeemail")} />
      </Form.Item>

      <div className={"customLabel"} style={{marginTop: 20, marginBottom: 10}}>
        {t("registercenter.orientador.title")}
      </div>
      <Form.Item
        rules={[
          {
            required: true,
            message: t("mandatory"),
          },
        ]}
        label={t("registercenter.orientador.nombre") + " " + parseInt(1)}
        name={"orientadornombre"}
      >
        <Input placeholder={t("registercenter.placenom")} />
      </Form.Item>
      <Form.Item
        rules={[
          {
            required: true,
            message: t("mandatory"),
          },
        ]}
        label={t("registercenter.orientador.apellidos") + " " + parseInt(1)}
        name={"orientadorapellidos"}
      >
        <Input placeholder={t("registercenter.placesur")} />
      </Form.Item>
      <Form.Item
        rules={[
          {
            type: "email",
            message: t("registro.emailIncorrect"),
          },
          {
            required: true,
            message: t("mandatory"),
          },
        ]}
        label={t("registercenter.orientador.email") + " " + parseInt(1)}
        name={"orientadoremail"}
      >
        <Input placeholder={t("registercenter.placeemail")} />
      </Form.Item>
      <Form.Item
        rules={[
          {
            required: true,
            message: t("mandatory"),
          },
        ]}
        label={t("registercenter.orientador.telefm") + " " + parseInt(1)}
        name={"orientadortelef"}
      >
        <Input placeholder={"XXX-XXX-XXX"} />
      </Form.Item>
      <Form.Item
        rules={[
          {
            required: true,
            message: t("mandatory"),
          },
          ({getFieldValue}) => ({
            validator(_, value) {
              var DNI_REGEX = /^(\d{8})([A-Z])$/;
              value = value.toUpperCase().replace(/\s/, "");
              if (value.match(DNI_REGEX)) {
                var dni_letters = "TRWAGMYFPDXBNJZSQVHLCKE";
                var letter = dni_letters.charAt(parseInt(value, 10) % 23);
                if (letter === value.charAt(8)) return Promise.resolve();
                else return Promise.reject(new Error(t("registro.baddni")));
              } else {
                return Promise.reject(new Error(t("registro.baddni")));
              }
            },
          }),
        ]}
        label={t("registercenter.orientador.dni") + " " + parseInt(1)}
        name={"orientadordni"}
      >
        <Input placeholder={"1234567X"} />
      </Form.Item>
      <Form.List name={"orientadores"}>
        {(fields, {add, remove}, {errors}) => (
          <>
            {fields.map((field, index) => (
              <>
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: t("mandatory"),
                    },
                  ]}
                  label={t("registercenter.orientador.nombre") + " " + parseInt(index + 2)}
                  name={[field.name, "nombre"]}
                >
                  <Input placeholder={t("registercenter.placenom")} />
                </Form.Item>

                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: t("mandatory"),
                    },
                  ]}
                  label={t("registercenter.orientador.apellidos") + " " + parseInt(index + 2)}
                  name={[field.name, "apellidos"]}
                >
                  <Input placeholder={t("registercenter.placesur")} />
                </Form.Item>
                <Form.Item
                  rules={[
                    {
                      type: "email",
                      message: t("registro.emailIncorrect"),
                    },
                    {
                      required: true,
                      message: t("mandatory"),
                    },
                  ]}
                  label={t("registercenter.orientador.email") + " " + parseInt(index + 2)}
                  name={[field.name, "email"]}
                >
                  <Input placeholder={t("registercenter.placeemail")} />
                </Form.Item>
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: t("mandatory"),
                    },
                  ]}
                  label={t("registercenter.orientador.telefm") + " " + parseInt(index + 2)}
                  name={[field.name, "telef"]}
                >
                  <Input placeholder={"XXX-XXX-XXX"} />
                </Form.Item>
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: t("mandatory"),
                    },
                    ({getFieldValue}) => ({
                      validator(_, value) {
                        var DNI_REGEX = /^(\d{8})([A-Z])$/;
                        value = value.toUpperCase().replace(/\s/, "");
                        if (value.match(DNI_REGEX)) {
                          var dni_letters = "TRWAGMYFPDXBNJZSQVHLCKE";
                          var letter = dni_letters.charAt(parseInt(value, 10) % 23);
                          if (letter === value.charAt(8)) return Promise.resolve();
                          else return Promise.reject(new Error(t("registro.baddni")));
                        } else {
                          return Promise.reject(new Error(t("registro.baddni")));
                        }
                      },
                    }),
                  ]}
                  label={t("registercenter.orientador.dni") + " " + parseInt(index + 2)}
                  name={[field.name, "dni"]}
                >
                  <Input placeholder={"1234567X"} />
                </Form.Item>
                <Form.Item className="alignBottomMobile">
                  <Space size={180} className="btnsForm">
                    <Button
                      type={"warning"}
                      className="primaryButton"
                      onClick={() => remove(field.name)}
                      icon={<MinusCircleOutlined />}
                    >
                      {t("registercenter.orientador.remove")}
                    </Button>
                  </Space>
                </Form.Item>
              </>
            ))}
            <Form.Item className="alignBottomMobile">
              <Space size={180} className="btnsForm">
                <Button className="primaryButton" onClick={() => add()} icon={<PlusOutlined />}>
                  {t("registercenter.orientador.add")}
                </Button>
              </Space>
            </Form.Item>
          </>
        )}
      </Form.List>
      <Form.Item className="buttons-pre-next">
        <Button className="primaryButton buttonSizeS" onClick={() => props.goTo(null, 0)} htmlType="button">
          {t("atras")}
        </Button>
        <Button loading={loading} className="primaryButton buttonSizeS" type="primary" htmlType="submit">
          {t("next")}
        </Button>
      </Form.Item>
    </Form>
  );
}

export default withTranslation()(StepTwoCenter);
